import * as React from "react";
import {Datagrid, DateField, EditButton, List, TextField} from 'react-admin';

export const StaticResourceList = () => (
    <List>
        <Datagrid>
            <TextField source="id" label="#"/>
            <TextField source="ref" label="путь"/>
            <DateField source="created" label="Создано"/>
            <DateField source="modified" label="Изменено"/>
            <EditButton />
        </Datagrid>
    </List>
);